import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import type { ProcessedFormField } from "@/types/api/formSchema";

type Props = {
  field: ProcessedFormField;
  value: boolean;
  onChange: (value: boolean) => void;
  onBlur: () => void;
  name: string;
};

export function BooleanField({
  field: schemaField,
  value,
  onChange,
  onBlur,
  name,
}: Props) {
  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            id={name}
            checked={!!value}
            disabled={!!schemaField.disabled}
            onChange={(e) => onChange(e.target.checked)}
            onBlur={onBlur}
            sx={{
              color: "primary.main",
              "&.Mui-checked": { color: "primary.main" },
            }}
          />
        }
        label={
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
            {schemaField.resolvedLabel}
            {schemaField.required && (
              <Box component="span" sx={{ color: "error.main", ml: 0.5 }}>
                *
              </Box>
            )}
          </Typography>
        }
        sx={{ ml: "-9px", mr: 0, my: 0 }}
      />
    </Box>
  );
}
